// TRADE-1010: maps a rejected `fixCsvImport` payload to a toast config so
// the CSV import + bulk-update handlers surface the right message instead of
// a generic error. Three distinct cases the backend can return:
//   - quota_exceeded: free-trial 10-query limit (upsell).
//   - limit_reached:  per-user/global dollar spend cap (429/503) or the
//                     256 KB / 5 MB size caps (413) — no upsell, just the msg.
//   - everything else: a real fixer failure.
// Kept as a pure function so it's unit-testable without rendering Summary.
export const resolveCsvFixRejection = (payload, { fallbackDescription } = {}) => {
  const p = payload || {};

  if (p.quota_exceeded) {
    return {
      title: "AI Quota Exceeded",
      description:
        "You've used all 10 free AI queries. Upgrade to a paid plan for unlimited access.",
      status: "warning",
      duration: 7000,
    };
  }

  if (p.limit_reached) {
    return {
      title: "AI Limit Reached",
      description: p.result || "AI is temporarily unavailable. Please try again later.",
      status: "warning",
      duration: 7000,
    };
  }

  // 413 size caps return { result }, agent failures return { error }; prefer
  // whichever real message is present over the generic fallback.
  return {
    title: "CSV Fix Failed",
    description: p.result || p.error || fallbackDescription || "Could not fix CSV.",
    status: "error",
    duration: 5000,
  };
};
